import { all, put, select, takeLatest } from 'redux-saga/effects';
import { formatDateTimeUTC, formatMonthIntervalUTC } from 'util/formatting';

import { activityIRRequest, activityIRSuccess, setRequestState } from './actions';

import axios from 'axios';
import { INCIDENT_REPORTS_V2 } from 'app/api-routes';
import { IR_STATUSES, SERVER_DATE_TIME_FORMAT } from 'app/types/constants';
import _ from 'lodash';
import CodeTypes from 'ducks/codes/types';
import { getCodes } from 'ducks/codes';

function* activityIRSaga({ payload: { date, startDate, typeIDs, endDate, siteID, userID, supervisorID } }) {
  const { userInfo } = yield select((state) => state.auth);
  const incidentTypes = yield select((state) => getCodes(state, CodeTypes.INCIDENT_TYPES));

  yield put(setRequestState(true));
  let statusFilter = null;
  if (userInfo.userType === 'C') {
    statusFilter = IR_STATUSES.APPROVED;
  }
  let fromDate, toDate;
  if (startDate != null && endDate != null) {
    fromDate = formatDateTimeUTC(startDate, SERVER_DATE_TIME_FORMAT);
    toDate = formatDateTimeUTC(endDate, SERVER_DATE_TIME_FORMAT);
  } else {
    [fromDate, toDate] = formatMonthIntervalUTC(date);
  }
  try {
    const params = {
      fromDate,
      toDate,
      status: statusFilter || null,
      siteID,
      supervisorID,
    };

    if (!_.isEmpty(typeIDs) && incidentTypes?.length !== typeIDs?.length) {
      params.typeIDs = typeIDs;
    }

    if (userID) {
      params.userID = userID;
    }

    const { payload } = yield axios.get(INCIDENT_REPORTS_V2, { params });

    yield put(activityIRSuccess(payload));
  } catch (err) {
    // yield put(activityIRFailure(err));
  } finally {
    yield put(setRequestState(false));
  }
}

export default function* () {
  yield all([yield takeLatest(activityIRRequest, activityIRSaga)]);
}
